import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, CardTitle, Divider, Drawer, Loading, Text } from '@reveni-io/reveni-ui'

import ProcessSteps from '@/common/components/ProcessSteps'

import ExportInventorySection from './ExportInventorySection/ExportInventorySection'
import ImportInventorySection from './ImportInventorySection/ImportInventorySection'
import ImportProgressModal from './ImportProgressModal/ImportProgressModal'
import ImportResultModal from './ImportResultModal/ImportResultModal'
import ImportSuccessModal from './ImportSuccessModal/ImportSuccessModal'
import { steps } from './constants'
import { isImportSuccessful } from './helpers'
import * as Styles from './styles'

const ImportInventoryDataDrawer = ({
  onClose,
  show,
  onSelectInventoryFile,
  onDeleteInventoryFile,
  loading,
  inventoryFile,
  exportEmails,
  onChangeExportEmails,
  exportTemplate,
  onChangeExportTemplate,
  exportFormat,
  onChangeExportFormat,
  onExportInventoryItems,
  inventoryError,
  onError,
  onImport,
  uploading,
  importInProgress,
  importCompleted,
  onCancelImport,
  importResult,
  showImportResultModal,
  onCloseImportResultModal,
  userEmail,
  exportedInventory,
  exportingInventory,
}) => {
  const { t } = useTranslation()
  const importSuccessful = isImportSuccessful(importResult)

  return (
    <>
      <Drawer show={show} onClose={onClose} size="l" options={{ showHeaderActions: false }}>
        <Loading show={loading} height="350">
          <CardTitle>{t('Exportar e importar datos de inventario')}</CardTitle>
          <Styles.Container>
            <Text>
              {t(
                'Actualiza tu inventario de forma masiva subiendo un archivo de inventario actualizado en CSV o Excel.'
              )}
            </Text>
            <ProcessSteps steps={steps.map(step => ({ title: t(step.title), description: t(step.description) }))} />
            <Divider />
            <ExportInventorySection
              exportEmails={exportEmails}
              onChangeExportEmails={onChangeExportEmails}
              exportTemplate={exportTemplate}
              onChangeExportTemplate={onChangeExportTemplate}
              exportFormat={exportFormat}
              onChangeExportFormat={onChangeExportFormat}
              onExportInventoryItems={onExportInventoryItems}
              exportedInventory={exportedInventory}
              exportingInventory={exportingInventory}
            />
            <Divider />
            <ImportInventorySection
              onSelectFile={onSelectInventoryFile}
              onDeleteFile={onDeleteInventoryFile}
              inventoryFile={inventoryFile}
              inventoryError={inventoryError}
              onError={onError}
            />
            <Styles.ActionsContainer>
              <Button onClick={onClose} variant="outlined" fullWidth>
                {t('Cancelar')}
              </Button>
              <ButtonWithSpinner
                fullWidth
                onClick={onImport}
                defaultLabel={t('Importar')}
                loadingLabel={t('Importando')}
                loading={uploading}
                disabled={uploading || !inventoryFile}
              />
            </Styles.ActionsContainer>
          </Styles.Container>
        </Loading>
      </Drawer>
      <ImportProgressModal
        show={importInProgress}
        completed={importCompleted}
        onCancel={onCancelImport}
        fileName={inventoryFile?.name}
      />
      <ImportResultModal
        show={showImportResultModal && !importSuccessful}
        onClose={onCloseImportResultModal}
        fileName={inventoryFile?.name}
        result={importResult}
        email={userEmail}
      />
      <ImportSuccessModal
        show={showImportResultModal && importSuccessful}
        onClose={onCloseImportResultModal}
        processedRows={importResult?.processed_rows}
      />
    </>
  )
}

export default ImportInventoryDataDrawer
